import React from 'react';

import { ListRow, Text } from '@betterment/samba-react';

import { formatContributionValue } from './utils';

import type { PayrollContributionConfig } from './types';
import type { SystemStyleObject } from '@betterment/samba-styled-system/types';

type Props = {
  config: PayrollContributionConfig;
  css?: SystemStyleObject;
};

export const BonusPayrollContributionRow: React.FC<Props> = ({ config }) => {
  const bonusText = formatContributionValue(config.bonusValue, config.destinationName);

  return (
    <ListRow key={`${config.id}-bonus`} css={{ padding: 'space.0', alignItems: 'start' }}>
      <ListRow.LeadingContent>
        <Text>{bonusText}</Text>
      </ListRow.LeadingContent>
    </ListRow>
  );
};
